import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../videoMeeting.constants";
import { verifyVideoMeetingAccess } from "../utils/verifyVideoMeetingAccess";
import type { VideoRoomAccessResponse } from "../videoMeeting.types";

export type UseVerifyVideoMeetingAccessArgs = {
  roomId: number | null;
  user: { id: number } | null;
  isEnabled?: boolean;
};

export function useVerifyVideoMeetingAccess({
  roomId,
  user,
  isEnabled = true,
}: UseVerifyVideoMeetingAccessArgs) {
  return useQuery<VideoRoomAccessResponse, Error>({
    queryKey: [QUERY_KEYS.VIDEO_ROOM_ACCESS, roomId],
    queryFn: () => verifyVideoMeetingAccess(roomId!),
    enabled: !!roomId && !!user && isEnabled,
    retry: false,
  });
}
